/**
 * WordPress Dependencies
 */
import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';

/**
 * External Dependencies
 */
import classNames from 'classnames';

const Save = props => {
    const { attributes } = props;
    const { uniqueId } = attributes;

    const blockProps = useBlockProps.save({
        className: classNames('wp-block-faqmate-accordions', uniqueId)
    });

    return (
        <div {...blockProps}>
            <div className="faqmate-accordions-wrapper">
                <InnerBlocks.Content />
            </div>
        </div>
    );
};

export default Save;
